import { userMain } from "../../models/userModels";
import { UserActionTypes } from "../actions/userAction";
import InitialState from "./initialState";

const initialState: userMain = InitialState.user;
export default function UserReducer(
  state: userMain = initialState,
  action: any
) {
  switch (action.type) {
    case UserActionTypes.Logout_Success_Action:
      return { ...initialState, userDetails: undefined };
    case UserActionTypes.User_Login_Success_Action:
      return { ...state, userDetails: action.payload };
    case UserActionTypes.Side_nav_Auto_Close_Open:
      return { ...state, sideNavClose: action.payload };
    case UserActionTypes.Get_All_Notification_Success_Action:
      return { ...state, get_all_notification: action.payload };
    case UserActionTypes.Offer_Letter_Listing_Success_Action:      
      return { ...state, offer_letter_list: action.payload };
    case UserActionTypes.Set_IPhone_Mode_Action:
      return { ...state, iphoneMode: action.payload };
    default:
      return state;
  }
}
